import { __extends, __makeTemplateObject } from "tslib";
import React from 'react';
import { css } from 'styled-components';
import { Box } from '../Box';
import { Button } from '../Button';
import Spinner from '../Spinner';
import { createComponent } from '../utils';
var Container = createComponent({
    name: 'Placeholder',
    style: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    min-height: 50px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    min-height: 50px;\n  "]))),
});
var Placeholder = (function (_super) {
    __extends(Placeholder, _super);
    function Placeholder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            delayed: false,
        };
        return _this;
    }
    Placeholder.prototype.componentDidMount = function () {
        this.runDelay();
    };
    Placeholder.prototype.componentWillUnmount = function () {
        clearTimeout(this.delayTimer);
    };
    Placeholder.prototype.runDelay = function () {
        var _this = this;
        if (this.props.delay !== undefined && this.props.delay <= 0) {
            return;
        }
        this.setState({ delayed: true }, function () {
            _this.delayTimer = setTimeout(function () {
                _this.setState({
                    delayed: false,
                });
            }, _this.props.delay);
        });
    };
    Placeholder.prototype.render = function () {
        var _a = this.props, children = _a.children, loading = _a.loading, error = _a.error, renderLoading = _a.renderLoading, renderError = _a.renderError, onReload = _a.onReload;
        if (loading && this.state.delayed) {
            return null;
        }
        if (loading) {
            return renderLoading ? (renderLoading()) : (React.createElement(Container, null,
                React.createElement(Spinner, null)));
        }
        if (error) {
            return renderError ? (renderError()) : (React.createElement(Container, { textAlign: "center" },
                React.createElement("strong", null, "Oh no!"),
                React.createElement(Box, { mt: 1, mb: 3 }, error),
                React.createElement(Button, { variant: "primary", outline: true, onClick: onReload }, "Try Again")));
        }
        return typeof children === 'function' ? children() : children;
    };
    Placeholder.defaultProps = {
        loading: false,
        delay: 250,
    };
    return Placeholder;
}(React.Component));
export default Placeholder;
var templateObject_1;
//# sourceMappingURL=Placeholder.js.map